export default function BlogFilter() {
  return {
    isOpen: false,
    activeFilterType: null,
    lockBodyScroll(status) {
      return status ? document.body.classList.add('overflow-hidden') : document.body.classList.remove('overflow-hidden');
    },
    toggleContent(type) {
      if (this.activeFilterType === type) {
        this.activeFilterType = null;
        this.isOpen = false;
      } else {
        this.activeFilterType = type;
        this.isOpen = true;
      }
    },
    toggleFilter() {
      this.isOpen = !this.isOpen;
      this.lockBodyScroll(this.isOpen);
    },
    closeFilter() {
      this.isOpen = false;
      this.lockBodyScroll(this.isOpen);
    },
    $delimiters: ['${', '}$'],
  };
}